export default __webpack_public_path__ + "static/data-vis-categorical-do-983c9724519e0642220d2ff9e14f7044.png";